import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);
        const thumbSwiperContainer = document.querySelector('[data-swiper="thumbnails"]');

        let thumbSwiper = null;

        if (thumbSwiperContainer) {
            let thumbSwiperOptions = thumbSwiperContainer.closest('[data-module-swiper]').getAttribute('data-options');
            thumbSwiperOptions = JSON.parse(thumbSwiperOptions.replace(/'/g, '"'));

            thumbSwiper = new Swiper(thumbSwiperContainer, {
                ...thumbSwiperOptions,
                freeMode: true,
                watchSlidesProgress: true,
            });
        }
        const swiperContainers = document.querySelectorAll('[data-swiper="swiper"]');

        swiperContainers.forEach((swiperContainer) => {
            let dataOptions = swiperContainer.closest('[data-module-swiper]').getAttribute('data-options');
            dataOptions = JSON.parse(dataOptions.replace(/'/g, '"'));

            new Swiper(swiperContainer, {
                modules: [Navigation, Thumbs],
                spaceBetween: 50,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                ...(thumbSwiper ? { thumbs: { swiper: thumbSwiper } } : {}),
                ...dataOptions,
            });
        });
    }
}
